export default function Marquee({ items, dark = false }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-serif italic text-2xl md:text-4xl px-8 whitespace-nowrap ${
              dark ? "text-cream/85" : "text-ink/80"
            }`}
          >
            {item}
          </span>
          <span className="w-2 h-2 rotate-45 bg-champagne shrink-0" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee-band"
      className={`overflow-hidden border-y py-6 md:py-8 ${dark ? "bg-espresso border-linedark" : "bg-cream2 border-line"}`}
    >
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
